import React, { useEffect, useState } from "react";
import {
  View,
  FlatList,
  SafeAreaView,
  TouchableOpacity,
  ScrollView,
} from "react-native";

import Text from "component/typography/Text";
import Icon from "component/typography/Icon";
import Separator from "component/section/Separator";
import ModalInfinityList from "component/picker/ModalInfinityList";

import { sizes, colors, strings } from "asset/constant";
import tinycolor from "tinycolor2";
import { styles } from "./styles";
import { useFlag } from "hook";

const ItemSeparator = () => (
  <Separator
    sidesSpace={2}
    size={"80%"}
    color={tinycolor(colors.border.light).lighten(10).toString()}
  />
);

export default function Picker(props: PickerT) {
  const { flg: pickerVisible, on: open, off: close } = useFlag();

  const {
    placeholder,
    value,
    data,
    icon,
    onSelect,
    hideError,
    error,
    disabled,
  } = props;
  const val = value as string;

  const [valueState, setValueState] = useState<undefined | string>(undefined);

  useEffect(() => {
    setValueState(val);
  }, [val]);

  const _renderItem = (args: { item?: PickerItemT }) => {
    const item = args.item;

    return (
      <TouchableOpacity
        activeOpacity={sizes.tapOpacity}
        style={styles.item}
        onPress={() => {
          onSelect && onSelect(item);
          setValueState(item?.title);
          close();
        }}
      >
        <Text weight={!item ? "bold" : "default"} size={!item ? "lg" : "md"}>
          {!item ? strings.pick : item.title}
        </Text>
      </TouchableOpacity>
    );
  };

  return (
    <>
      <>
        <TouchableOpacity
          disabled={disabled}
          onPress={open}
          style={{ ...styles.container }}
          activeOpacity={sizes.tapOpacity}
        >
          <View style={styles.iconContainer}>
            <Icon name="down" size={12} />
          </View>
          <View style={styles.textContainer}>
            <Text
              size={"sm"}
              weight="bold"
              color={valueState ? colors.text.normal : colors.text.placeholder}
            >
              {" "}
              {valueState ?? placeholder ?? strings.pick}
            </Text>
          </View>
          {icon && (
            <View style={styles.iconContainer}>
              <Icon {...icon} />
            </View>
          )}
        </TouchableOpacity>

        {!hideError && (
          <View style={styles.errorContainer}>
            <Text size={"xs"} color={colors.danger}>
              {error}
            </Text>
          </View>
        )}
      </>

      <ModalInfinityList visible={pickerVisible} close={close}>
        {data && data?.length > 0 && (
          <ScrollView>
            {[undefined, ...data]?.map((item, key) => {
              return (
                <TouchableOpacity
                  key={String(key)}
                  activeOpacity={sizes.tapOpacity}
                  style={styles.item}
                  onPress={() => {
                    onSelect && onSelect(item);
                    setValueState(item?.title);
                    close();
                  }}
                >
                  <Text
                    weight={!item ? "bold" : "default"}
                    size={!item ? "lg" : "md"}
                  >
                    {!item ? strings.pick : item.title}
                  </Text>
                </TouchableOpacity>
              );
            })}
          </ScrollView>
        )}
      </ModalInfinityList>
    </>
  );
}
